import { render, staticRenderFns } from "./azure-wi.vue?vue&type=template&id=a298e62a&scoped=true&"
import script from "./azure-wi.vue?vue&type=script&lang=js&"
export * from "./azure-wi.vue?vue&type=script&lang=js&"
import style0 from "./azure-wi.vue?vue&type=style&index=0&id=a298e62a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a298e62a",
  null
  
)

export default component.exports